export default "__VITE_ASSET__dc364393__"